import client from './client';
import { VehicleReminder, ReminderType } from '../types/entities';

export interface CreateReminderRequest {
  vehicleId: number;
  type: ReminderType;
  name: string;
  expiryDate?: string;
  dueOdometer?: number;
  note?: string;
}

export interface UpdateReminderRequest {
  name?: string;
  expiryDate?: string;
  dueOdometer?: number;
  note?: string;
}

export interface ResolveReminderRequest {
  nextDueOdometer?: number;
  nextExpiryDate?: string;
}

export const reminderAPI = {
  getByVehicle: async (vehicleId: number, includeResolved = true): Promise<VehicleReminder[]> => {
    const response = await client.get(`/reminders/vehicle/${vehicleId}`, {
      params: { includeResolved },
    });
    return response.data.data;
  },

  getById: async (id: string): Promise<VehicleReminder> => {
    const response = await client.get(`/reminders/${id}`);
    return response.data.data;
  },

  create: async (data: CreateReminderRequest): Promise<VehicleReminder> => {
    const response = await client.post('/reminders', data);
    return response.data.data;
  },

  update: async (id: string, data: UpdateReminderRequest): Promise<VehicleReminder> => {
    const response = await client.put(`/reminders/${id}`, data);
    return response.data.data;
  },

  resolve: async (id: string, data?: ResolveReminderRequest): Promise<VehicleReminder> => {
    const response = await client.patch(`/reminders/${id}/resolve`, data || {});
    return response.data.data;
  },

  delete: async (id: string): Promise<void> => {
    await client.delete(`/reminders/${id}`);
  },
};
